<template>
  <v-text-field
    type="text"
    v-model="displayValue"
    @blur="isInputActive = false"
    @focus="isInputActive = true"
    outlined
    :label="label"
    :rules="rules"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    @change="formatWithCurrency"
  />
</template>

<script>
export default {
  props: ["value", "label", "rules", "required", "readonly", "disabled"],
  data: function () {
    return {
      isInputActive: false,
    };
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString();
        } else {
          let inValue =
            typeof this.value != "number" ? Number(this.value) : this.value;
          // User is not modifying now. Format display value for user interface
          let value = inValue
            .toFixed(2)
            //   .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
            .split("");
          value[value.length - 3] = ",";
          return value.join("") + " €";
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(",", "."));
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0;
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    formatWithCurrency() {
      this.$emit("formatWithCurrency");
    },
  },
};
</script>

<style></style>
